export default "__VITE_ASSET__DtmGbbB8__"